import { render } from "./Tags.vue?vue&type=template&id=0d62be58&scoped=true"
import script from "./Tags.vue?vue&type=script&lang=ts"
export * from "./Tags.vue?vue&type=script&lang=ts"

import "./Tags.vue?vue&type=style&index=0&id=0d62be58&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0d62be58"

export default script